module.exports = __webpack_public_path__ + "static/media/29ADMSPC21.74a9b964.jpg";